import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsWriteReviewClickedParams = {
  trail_id?: number;
};

/**
 * A user clicks the 'Write a Review' CTA on the trail details page.
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsWriteReviewClicked = ({ trail_id }: logTrailDetailsWriteReviewClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('trail details write review clicked', { 'trail id': trail_id }, callback);
};

export default logTrailDetailsWriteReviewClicked;
